import { Endpoints, Http, HttpService } from "@/infra/api";
import { PlanEntity } from "@/domain/entities";
import { Plan } from "@/domain/models";
import { ApiResponse, ApiQuery, PlanDTO } from "@/@types";

export interface PlansRepository {
  getPlans: (query?: ApiQuery) => Promise<ApiResponse<Plan[]>>;
  getPlan: (id: string) => Promise<ApiResponse<Plan>>;
  createPlan: (params: PlanDTO) => Promise<ApiResponse<Plan>>;
  updatePlan: (id: string, params: PlanDTO) => Promise<ApiResponse<Plan>>;
  deletePlan: (id: string) => Promise<ApiResponse<PlanEntity>>;
}

export const PlanService = (http: Http = HttpService()): PlansRepository => ({
  getPlans: async (query) => {
    const res = await http.get<PlanEntity[]>(Endpoints.pricing_profiles, query);
    const data = res.data?.length ? res.data.map((user) => new Plan(user)) : [];
    return { ...res, data };
  },
  getPlan: async (id) => {
    const res = await http.get<PlanEntity>(
      `${Endpoints.pricing_profiles}/${id}`
    );
    const data = new Plan(res.data);
    return { ...res, data, entity: res.data };
  },
  createPlan: async (params) => {
    const res = await http.post<PlanDTO, PlanEntity>(
      Endpoints.pricing_profiles,
      params
    );
    const data = new Plan(res.data);
    return { ...res, data };
  },
  updatePlan: async (id, params) => {
    const res = await http.put<PlanDTO, PlanEntity>(
      `${Endpoints.pricing_profiles}/${id}`,
      params
    );
    const data = new Plan(res.data);
    return { ...res, data };
  },
  deletePlan: (id) => {
    return http.delete<PlanEntity>(`${Endpoints.pricing_profiles}/${id}`);
  },
});
